import { DA } from "@/data/da";

const SITE = "https://sinthunathan.com";

export const KOLDING_CV = {
  ...DA.cv,
  role: "UX Researcher · mennesker, processer og digitale løsninger",
  profile:
    "Jeg forstår mennesker og processer, og jeg omsætter det, jeg finder, til løsninger, der virker i praksis. I fire år hos Universal Robots kortlagde jeg arbejdsgange sammen med operatører, QA og fabrikschefer i Asien, Europa og USA, faciliterede workshops med fagpersoner og ledelse og omsatte input til procesbeskrivelser, krav og en benchmarkmodel, ledelsen traf beslutninger på. I Tennis Club Odense har jeg selv bygget og driftet en digital løsning til tilmelding og betaling, fulgt op på fejl og optimeret løbende. Jeg arbejder metodisk, stiller de spørgsmål, der udfordrer plejer, og følger opgaven helt til dørs.",
  metrics: [
    { value: "200+", label: "Interviews og arbejdsgangsanalyser med fagpersoner på tre kontinenter" },
    { value: "12", label: "Touchpoints kortlagt i én arbejdsgang, fra levering til første program" },
    { value: "PM → CEO", label: "Procesbeskrivelser og benchmark præsenteret fra product manager til direktion" },
    { value: "1", label: "Digital løsning bygget, driftet og optimeret selv, med 478 brugere" },
  ],
  experience: [
    "Digitaliserede tilmelding og betaling for Fyns største tennisklub (478 medlemmer): byggede flowet selv, følger op på fejl, måler tilfredshed (CSAT) og optimerer løbende.",
    "Arbejdsgangsanalyser, journey maps og procesbeskrivelser for fødevare- og pharmaindustrien; workshops med fagpersoner, krav til digitale løsninger og en Power BI-benchmark, rapporteret fra PM til CEO.",
    "Detailledelse, kundevendt drift og struktur i et team.",
  ],
  deliverables: [
    "Arbejdsgangsanalyser",
    "Procesbeskrivelser",
    "Kortlægning og journey maps",
    "Facilitering af workshops",
    "Krav til digitale løsninger",
    "Dashboards og opfølgning (Power BI)",
    "Målinger: CSAT, NPS og analytics",
  ],
  footer: `Interaktiv portfolio og ordrette anbefalinger: ${SITE}/?for=proces`,
};

export const KOLDING_COVER = {
  label: "Ansøgning · Procesudvikler, Systemadministration og Procesudvikling",
  role: "Procesudvikler",
  attn: "Kolding Kommune · Processer og Regnskab · Att. teamleder Luna Holm Mouritsen",
  heading: "Jeg får mennesker til at tale om deres arbejdsgange, og arbejdsgangene omsat til løsninger.",
  dear: "Kære Luna,",
  paragraphs: [
    "I søger en kollega, der både kan forstå mennesker og processer og omsætte det til konkrete løsninger. Det er præcis det, jeg har arbejdet med i fem år: først som UX Researcher hos Universal Robots, siden som den, der selv byggede og driftede den digitale løsning i Tennis Club Odense.",
    "Hos Universal Robots kortlagde jeg arbejdsgange sammen med operatører, QA og fabrikschefer i Asien, Europa og USA. Jeg faciliterede workshops med fagpersoner og ledere, omsatte input til procesbeskrivelser og krav til digitale løsninger og byggede den benchmarkmodel, ledelsen traf beslutninger på. Metoden var altid den samme: forstå, hvordan opgaven løses i dag, finde behov og udfordringer, beskrive processen og forbedre den.",
    "I Tennis Club Odense har jeg selv digitaliseret tilmelding og betaling for 478 medlemmer: bygget flowet, fulgt op på fejl, målt tilfredshed og optimeret løbende. Jeg har ikke arbejdet i X-flow endnu, men jeg har bygget og driftet et blanket- og flowsystem fra bunden med API-integrationer, og jeg sætter mig hurtigt ind i nye systemer.",
    `Jeg er tryg ved at tage rummet, stille de spørgsmål, der udfordrer plejer, og skabe struktur i input fra mange perspektiver. Jeg kan tiltræde 1. december 2026 eller efter aftale. Min portfolio, ${SITE}/?for=kolding, viser metoden i praksis, og jeg uddyber gerne til en samtale.`,
  ],
  regards: "Med venlig hilsen",
  enclosed: "Vedlagt: CV",
  references: `Referencer: ${SITE}/#testimonials`,
  locale: "da-DK",
};

export const KOLDING_HERO = {
  title: "Researcher med blik for",
  titleEm: "mennesker, processer",
  titleTail: "og digitale løsninger",
  proof: "200+ interviews og arbejdsgangsanalyser på tre kontinenter · workshops med fagpersoner og ledelse · digitale løsninger bygget og driftet selv",
  cv: "/downloads/Sinthu-Nathan-CV-Proces.pdf?v=20261011",
};
